import React from 'react';
import { TrendingUp, TrendingDown, CheckCircle } from 'lucide-react';

const CpdProjection = ({ currentHours, requiredHours }) => {
    const currentMonth = new Date().getMonth() + 1; // Get current month (1-12)
    const averageMonthlyHours = currentHours / currentMonth;
    const projectedTotal = averageMonthlyHours * 12;

    let status = 'on-track';
    if (projectedTotal < requiredHours) {
        status = 'behind';
    } else if (currentHours >= requiredHours) {
        status = 'complete';
    }

    const statusInfo = {
        'on-track': {
            Icon: TrendingUp,
            color: 'text-green-500',
            text: `At your current pace, you are projected to log ${projectedTotal.toFixed(0)} hours this year.`
        },
        'behind': {
            Icon: TrendingDown,
            color: 'text-yellow-500',
            text: `At your current pace, you are projected to log ${projectedTotal.toFixed(0)} hours this year.`
        },
        'complete': {
            Icon: CheckCircle,
            color: 'text-blue-500',
            text: `Congratulations! You have met your annual CPD requirement.`
        }
    };

    const currentStatus = statusInfo[status];

    return (
        <div className="bg-gray-100 dark:bg-gray-800 p-6 rounded-xl shadow-lg border border-gray-300 dark:border-gray-700">
             <h3 className="text-lg font-bold text-blue-800 dark:text-blue-300 mb-3">Annual Projection</h3>
             <div className={`flex items-center ${currentStatus.color}`}>
                <currentStatus.Icon size={24} className="mr-3 flex-shrink-0" />
                <p className="text-gray-700 dark:text-gray-300">{currentStatus.text}</p>
             </div>
        </div>
    );
};

export default CpdProjection;